import { useI18n } from '@radical/locale'
import { LAYOUT } from '../basic'

const { t } = useI18n()

const record: RouteRecordItem = {
  path: '/record',
  name: 'Record',
  component: LAYOUT,
  redirect: { name: 'RecordMp4' },
  meta: {
    orderNo: 5,
    icon: 'gridicons:video',
    title: t('routes.record.录像回放'),
    hideChildrenInMenu: true,
  },
  children: [
    {
      path: 'mp4',
      name: 'RecordMp4',
      component: () => import('@/pages/record/mp4.vue'),
      meta: {
        title: t('routes.record.本地录像'),
      },
    },
  ],
}

export default record
